{
  "blocks": [
    {
      "id": "dx-hypothyroidism",
      "kind": "condition",
      "tags": ["her", "thyroid", "evidence-based"],
      "title": "Hypothyroidism (subclinical)",
      "subtitle": "Underactive thyroid affecting reproductive hormones",
      "body": {
        "conditionName": "Hypothyroidism (subclinical)",
        "category": "endocrine",
        "description": "Subclinical hypothyroidism means your TSH is mildly elevated while thyroid hormones (T3, T4) remain in the normal range. Even this mild dysfunction can impact fertility. Thyroid hormones play a critical role in ovulation, implantation, and early pregnancy maintenance. In fertility treatment, tighter TSH targets (< 2.5 mIU/L) are recommended.",
        "symptoms": [
          "Often no noticeable symptoms",
          "Fatigue",
          "Weight gain or difficulty losing weight",
          "Feeling cold",
          "Dry skin and hair",
          "Constipation",
          "Slightly irregular periods"
        ],
        "howDiagnosed": "Diagnosed through blood tests showing elevated TSH (typically 2.5–10 mIU/L for subclinical) with normal free T4 levels. Thyroid antibodies (TPO, TG) are also checked, as Hashimoto's thyroiditis is the most common cause. Fertility specialists use a stricter TSH cutoff of < 2.5 mIU/L.",
        "impactOnFertility": "Even mildly elevated TSH is associated with longer time to conception, higher miscarriage rates, and potentially lower IVF success. Thyroid autoimmunity (positive antibodies) independently increases miscarriage risk. Treatment with levothyroxine is simple and effective.",
        "prevalence": "Subclinical hypothyroidism affects 4–8% of women of reproductive age. Thyroid autoimmunity is found in 5–15%.",
        "treatmentOptions": [
          "Levothyroxine (synthetic T4), daily oral medication",
          "Target TSH < 2.5 mIU/L during fertility treatment and pregnancy",
          "Selenium supplementation for thyroid antibodies (moderate evidence)",
          "Regular TSH monitoring (every 4–6 weeks during pregnancy)"
        ],
        "prognosis": "Excellent with treatment. Levothyroxine is well-tolerated and effectively normalizes fertility outcomes. Once TSH is in target range, success rates are comparable to women without thyroid issues.",
        "forWhom": "her"
      },
      "sources": [
        {
          "title": "2017 Guidelines of the American Thyroid Association for the Diagnosis and Management of Thyroid Disease During Pregnancy and the Postpartum",
          "authors": "Alexander EK, Pearce EN, Brent GA, et al.",
          "journal": "Thyroid",
          "year": 2017,
          "url": "https://pubmed.ncbi.nlm.nih.gov/28056690/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Subclinical hypothyroidism in the infertile female population: a guideline",
          "authors": "Practice Committee of the ASRM",
          "journal": "Fertility and Sterility",
          "year": 2015,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/",
          "evidenceLevel": "guideline"
        }
      ]
    },
    {
      "id": "dx-hyperprolactinemia",
      "kind": "condition",
      "tags": ["her", "evidence-based"],
      "title": "Hyperprolactinemia",
      "subtitle": "Elevated prolactin levels disrupting ovulation",
      "body": {
        "conditionName": "Hyperprolactinemia",
        "category": "endocrine",
        "description": "Hyperprolactinemia is a condition where the pituitary gland produces too much prolactin, the hormone responsible for breast milk production. Elevated prolactin suppresses GnRH, which in turn suppresses FSH and LH, the hormones needed for ovulation. Common causes include pituitary adenomas (small benign tumors), certain medications, and stress.",
        "symptoms": [
          "Irregular or absent periods",
          "Milky nipple discharge (galactorrhea)",
          "Headaches or visual changes (if pituitary adenoma)",
          "Difficulty conceiving",
          "Low libido"
        ],
        "howDiagnosed": "Diagnosed through a blood test showing elevated prolactin levels (typically > 25 ng/mL). An MRI of the pituitary gland is ordered to check for a prolactinoma. Stress, certain medications, and even the blood draw itself can temporarily elevate prolactin, so repeat testing may be needed.",
        "impactOnFertility": "High prolactin directly suppresses ovulation, making conception difficult or impossible without treatment. However, it's one of the most treatable hormonal causes of infertility.",
        "prevalence": "Accounts for roughly 10–20% of cases of absent periods (amenorrhea).",
        "treatmentOptions": [
          "Cabergoline (first-line medication, very effective)",
          "Bromocriptine (alternative medication)",
          "Surgery (rarely needed, only for large or resistant tumors)",
          "Discontinuing causative medications when possible"
        ],
        "prognosis": "Excellent. Medication normalizes prolactin in 80–90% of cases, and ovulation typically resumes within weeks to months. Pregnancy rates after treatment are comparable to the general population.",
        "forWhom": "her"
      },
      "sources": [
        {
          "title": "Diagnosis and treatment of hyperprolactinemia: an Endocrine Society clinical practice guideline",
          "authors": "Melmed S, Casanueva FF, Hoffman AR, Kleinberg DL, Montori VM, Schlechte JA, Wass JAH",
          "journal": "Journal of Clinical Endocrinology & Metabolism",
          "year": 2011,
          "url": "https://www.endocrine.org/clinical-practice-guidelines/hyperprolactinemia",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
